import { GroupSecurity } from '@quromedical/fhir-common';
import { Location } from '@quromedical/models';
import { LocationFormCard } from 'core/location';
import { Alert, Section, Skeleton, SkeletonProvider, Snackbar } from 'design-system';
import { useUserSession } from 'hooks/useUserSession';
import { organizationFetcher } from 'integration';
import { DeviceStackScreenProps } from 'navigation';
import React, { useCallback } from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { strings } from 'strings';
import { trpc } from 'trpc';

export const LocationScreen: React.FC<DeviceStackScreenProps<'View'>> = ({ route }) => {
  const { id } = route.params;

  const userSession = useUserSession();

  const canEdit = userSession.hasAny([GroupSecurity.LocationUpdate]);

  const orgFetcher = organizationFetcher();

  const {
    data = {},
    isFetching: isValidating,
    isError: error,
    refetch,
  } = trpc.context.location.getById.useQuery({ id });

  const revalidate = useCallback(async () => {
    await refetch();
    await userSession.getGroups();
  }, [userSession, refetch]);

  return (
    <ScrollView>
      <SkeletonProvider loading={isValidating}>
        <Section>
          <Skeleton>
            <LocationFormCard
              canEdit={canEdit}
              revalidate={revalidate}
              data={data as Location}
              id={id}
              organizationFetcher={orgFetcher}
            />
          </Skeleton>
          <Snackbar isOpen={error} onClose={revalidate}>
            <Alert
              actionIcon="close"
              backgroundColor="status-critical"
              title={strings.AlertError}
              onAction={revalidate}
              body={strings.DeviceCreateError}
            />
          </Snackbar>
        </Section>
      </SkeletonProvider>
    </ScrollView>
  );
};
